export default __webpack_public_path__ + "static/media/dropdown_icon.66d7bd85.svg";